import { Reducer } from "redux";
import {
  CheckinReleaseState,
  CheckinReleaseTypes,
} from "./types";

export const INITIAL_STATE: CheckinReleaseState = {
  data: [],
  loading: false,
  success: false,
  error: false,
};

const reducer: Reducer<CheckinReleaseState> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case CheckinReleaseTypes.LOAD_REQUEST:
      return { ...state, loading: true };

    case CheckinReleaseTypes.LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case CheckinReleaseTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
